import type { Currency } from 'types/account';

const cache = new WeakMap<ReadonlyArray<any>, Currency | undefined>();

const defaultIteratee = <T>(item: T): Currency | undefined => (item as any).currency;

/**
 * Returns the currency if there is only a single currency, or `undefined` otherwise.
 */
export function extractSingleCurrency<T extends { currency?: Currency }>(
  items: ReadonlyArray<T>
): Currency | undefined;

export function extractSingleCurrency<T extends {}>(
  items: ReadonlyArray<T>,
  iteratee: (item: T) => Currency | undefined
): Currency | undefined;

export function extractSingleCurrency<T extends {}>(
  items: ReadonlyArray<T>,
  iteratee = defaultIteratee
): Currency | undefined {
  if (iteratee === defaultIteratee && cache.has(items)) {
    return cache.get(items);
  }

  let currency: Currency | undefined;
  for (const item of items) {
    const itemCurrency = iteratee(item);
    if (!currency) {
      currency = itemCurrency;
    } else if (itemCurrency && currency.id !== itemCurrency.id) {
      return;
    }
  }

  if (iteratee === defaultIteratee) {
    cache.set(items, currency);
  }

  return currency;
}
